<template>
  <v-container fluid>
    <h1>{{name}}</h1>
    <v-row class="ma-0">
      <v-spacer />
        <the-date-picker
          v-if="dates.length >= 2"
          :initialDates="dates"
          :pickerOptions="pickerOptions"
          @setDate="setReportingDates"
        />
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card width="100%">
          <v-card-title>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
          </v-card-title>
          <campaigns-overview-campaigns-table
            :campaigns="filteredCampaigns"
            :search="search"
            @editCampaign="editCampaign"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import TheDatePicker from '../../helpers/TheDatePicker.vue'
import CampaignsOverviewCampaignsTable from './CampaignsOverviewCampaignsTable.vue'
export default {
  name: 'campaigns-factory',
  components: {
    TheDatePicker,
    CampaignsOverviewCampaignsTable
  },
  data () {
    return {
      dialog: false,
      editedCampaignId: null,
      dates: [],
      pickerOptions: {
        disabledDate (time) {
          return moment(time).unix() > moment().unix()
        }
      },
      search: ''
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    adlabels: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    if (!this.reportingDates.length) {
      this.dates.push(this.$moment().subtract(1, 'month')._d)
      this.dates.push(this.$moment()._d)
    } else {
      this.dates.push(this.reportingDates[0])
      this.dates.push(this.reportingDates[1])
    }
  },
  computed: {
    ...mapGetters({
      campaigns: 'getCampaigns'
    }),
    reportingDates () {
      return this.$store.getters.getReportingDates
    },
    filteredCampaigns () {
      if (!this.adlabels.length) return this.searchedCampaigns
      return this.searchedCampaigns
        .filter(c => c.adlabels && c.adlabels.find(l => this.adlabels.find(label => label === l.name)))
    },
    searchedCampaigns () {
      return this.campaigns.filter(c => c.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
    }
  },
  methods: {
    editCampaign (id) {
      this.$router.push({name: 'EditCampaign', params: {id}})
    },
    setReportingDates (dates) {
      this.$store.commit('helpers/SET_REPORTING_DATES', dates)
      const payload = {
        startDate: this.$moment(this.reportingDates[0]).format('YYYY-MM-DD'),
        endDate: this.$moment(this.reportingDates[1]).format('YYYY-MM-DD')
      }
      this.$store.dispatch('updateInsights', payload)
    },
    closeDialog () {
      this.editedCampaignId = null
      this.dialog = false
    }
  },
  watch: {
    reportingDates (val) {
      this.dates = []
      if (val) {
        this.dates.push(val[0])
        this.dates.push(val[1])
      }
    }
  }
}
</script>
<style scoped>

</style>
